<template>
  <NavBarWeb />
  <div class="sectionKoko">
    <div class="container" style="text-align: left">
      <div class="sectionHead mt-5">Terms and Conditions</div>

      <p><b>CUSTOMER AGREEMENT</b></p>
      

      <p>Dinnovation (Private) Limited (PV0225927), hereinafter sometimes referred to as &ldquo;we&quot;,
        &quot;us&quot;, &ldquo;KOKO&rdquo;, &ldquo;Pay KOKO&rdquo; or &quot;Dinnovation&quot; provide access to this
        KOKO__website_ (the &quot;KOKO&quot;) to you subject to the conditions set out on this page. Please read these
        Terms and Conditions carefully before using KOKO.<br>
        <br>
        This document is an electronic record in terms of Electronic Transactions Act. No 19 of 2006 and rules
        thereunder as applicable and the amended provisions pertaining to electronic records in various statutes as
        amended by the Electronics Transactions Act No. 19 of 2006.<br>
        <br>
        This electronic record is generated by a computer system and does not require any physical or digital
        signatures.<br>
        <br>
        INTRODUCTION<br>
        <br>
        W These are the terms and conditions governing your access and use of KOKO along with its related sub-domains,
        sites, mobile app, payment system, services and tools (the &quot;Site&quot;). By using the Site, you hereby
        accept these terms and conditions (including the linked information herein) and represent that you agree to
        comply with these terms and conditions (the &quot;User Agreement&quot;). In addition, when you use any current
        or future KOKO&rsquo; services, you will also be subject to the terms, guidelines and conditions applicable to
        each KOKO service/s. (&quot;Terms&quot;). If these Conditions of Use are inconsistent with such Terms, the Terms
        will control. This User Agreement is deemed effective upon your use of the Site which signifies your acceptance
        of these terms. If you do not agree to be bound by this User Agreement please do not access, register with or
        use this Site. <br>
      </p>

      <p>
        We reserve the right to change, modify, add, or remove portions of these Terms and Conditions at any time
        without any prior notification. Changes will be effective when posted on the Site with no other notice provided.
        Please check these Terms and Conditions regularly for updates. Your continued use of the Site following the
        posting of changes to Terms and Conditions of use constitutes your acceptance of those changes.</p>

      <p>SERVICES<br>
        <br>
        Under this User Agreement, KOKO will grant you access to and use of Site, which will give you the ability to
        purchase items and/or services from participating merchants (&ldquo;Products&rdquo;) through their e-commerce
        and /or offline Stores and make payment for such purchases via separate and equal instalments as determined by
        KOKO without interest through the system developed by us for the implementation and administration of an online
        instalment payment solution, which includes performing validation checks and assessments on consumers
        (&ldquo;Services&rdquo;). Participating merchants shall mean approved retailers or retail merchants that allow
        customers to purchase Products from their stores online or otherwise and make payment via instalments using the
        Site (&ldquo;Participating Merchants&rdquo;).
      </p>

      <p>For the avoidance of doubt, the Site does not constitute a lending or credit facility and KOKO does not provide
        any credit to merchants or consumers.</p>

      <p>CONDITIONS OF USE<br>
        <br>
        Your Account<br>
        <br>
        To access the Services offered by the Site, we require that you create an account with us or provide personal
        information to complete the creation of an account in order for you to manage your orders and repayment schedule
        (&ldquo;Account&rdquo;). <br>
        <br>
        You are responsible for maintaining the confidentiality of your user identification, password, account details
        and related private information. You agree to accept this responsibility and ensure your Account and its related
        details are maintained securely at all times and all necessary steps are taken to prevent misuse of your
        Account. You should inform us immediately if you have any reason to believe that your password has become known
        to anyone else, or if the password is being, or is likely to be, used in an unauthorized manner. You agree and
        acknowledge that any use of the Site and related services offered and/or any access to private information, data
        or communications using your Account and password shall be deemed to be either performed by you. You agree to be
        bound by any access of the Site and/or use of Services offered by the Site (whether such access or use are
        authorized by you or not). You agree that we shall be entitled (but not obliged) to act upon, rely on or hold
        you solely responsible and liable in respect thereof as if the same were carried out or transmitted by you. You
        further agree and acknowledge that you shall be bound by and agree to fully indemnify us against any and all
        losses arising from the use of or access to the Site through your Account.
      </p>

      <p>Please ensure that the details you provide us with are correct and complete at all times. You are obligated to
        update details about your Account in real time by accessing your Account online. For pieces of information you
        are not able to update by accessing your Account on the Site, you must inform us via our customer service
        communication channels to assist you with these changes. We may at any time in our sole and absolute discretion,
        request that you update your personal data or forthwith invalidate the Account or related details without giving
        any reason or prior notice and shall not be liable or responsible for any losses suffered by or caused by you or
        arising out of or in connection with or by reason of such request or invalidation. You hereby agree to change
        your password from time to time and to keep your Account secure and also shall be responsible for the
        confidentiality of your Account and liable for any disclosure or use (whether such use is authorized or not) of
        the username and/or password.</p>

      <p>You shall use the Site and your Account in accordance with the operating procedures as may be determined by us
        from time to time. You shall have only one Account.</p>

      <p>We shall be entitled to limit your access to your Account in the following ways:<br>
        Where you have failed to pay any Instalment(s) (defined below) by the scheduled due date and within any
        accompanying grace period (where applicable), we reserve the right to suspend you from making further orders and
        subsequently, where your debts to us have been referred to a third party debt collection agency, we will block
        access to your Account.<br>
        <br>
        Where we have reasonable cause to suspect that you have been involved in any immoral, deceitful, fraudulent,
        and/ or unlawful act within the Site and where devices, email accounts and/or phone numbers are being used to
        perform an order or create an Account and such devices, email addresses and/or phone numbers are reasonably
        suspected by us to be involved in connection with any unlawful act within the Site we:<br>
        <br>
        Reserve the right to conduct investigations, with internal and external third-parties, to determine the extent
        and impact of the suspected conduct;<br>
        Reserve the right to seek your cooperation and assistance in dealing with such activities, which you hereby
        covenant to comply with;<br>
        Reserve the right to request immediate payment from you for all outstanding debts only to us;<br>
        Reserve the right to suspend any Account associated with you until such time as such act is halted or restricted
        to our satisfaction;<br>
        Reserve the right to temporarily suspend or permanently block you from using or participating Site or its
        network of Participating Merchants;<br>
        Reserve the right,, at our sole discretion, to close any Account(s) whether associated with the suspected act or
        otherwise; and reserves the right to report such behavior to the relevant authorities.<br>
        <br>
        You may close your Account at any time provided that:<br>
        <br>
        You have paid in full all Instalments associated with your orders, and there are no outstanding debts owed by
        you to us that have been referred to a third party for collection and no suitable repayment plan as agreed by us
        is still ongoing;<br>
        You have paid all late payment charges imposed on you, or such late payment charge has been reversed (subject to
        our sole discretion);<br>
        There are no outstanding disputes between you and us or any Participating Merchant;<br>
        There are no outstanding refunds or reversals from a Participating Merchant that are still pending processing;
        and<br>
        You are not subject to any investigation regarding your orders, instalments or any other reason as reasonably
        determined by us.<br>
        <br>
        We shall be entitled to close your Account:<br>
        <br>
        Without your consent or prior notice, if we become aware that any Account associated with you is being used by a
        third party or has been compromised in any way whether as a result of your actions or inactions or
        otherwise;<br>
        If we consider that you are using the Site and its services inappropriately, illegally, or against the spirit of
        this User Agreement;<br>
        If you have not paid your outstanding debts to us and:<br>
        Your failure to pay persists despite we putting in place a suitable repayment plan;<br>
        Your outstanding debts have been referred to a third-party agency for collection; and such collection has been
        carried out with limited or no success.<br>
        <br>
        In such case you shall not be able to open another Account with us for a period of three (3) years or any other
        period of time that is deemed appropriate by law or regulation, and we reserve the rights to:<br>
        <br>
        Pursue any outstanding sums due and owing to us in connection with this User Agreement through third-parties and
        relevant legal means available to us;<br>
        Notify any credit reporting agency or bureau located in Sri Lanka or any agency or bureau that reports such
        credit reporting information to Sri Lankan companies, and identify any outstanding debts against your known
        details to us as at the date of termination of this User Agreement;<br>
        Should you fail to meet the eligibility requirements set out below on an ongoing basis, we reserve the right to
        suspend, block, withdraw, close or otherwise render inoperable your Account.
      </p>

      <p>Eligibility</p>

      <p>In order to be eligible to receive the Services, you must:</p>

      <p>Be a natural person and not a company, partnership or other commercial or noncommercial entity;<br>
        Be at least 18 years old of age;<br>
        Have a valid email address;<br>
        Have a mobile telephone number issued by a Sri Lankan telecommunications carrier;<br>
        Have a billing address and shipping address located in Sri Lanka; and<br>
        Own a valid credit card or debit card which you can use to make payments on the Site.</p>

      <p>Your eligibility is assessed and determined upon each order you make, and we reserve the right to deny, suspend
        or terminate the provision of the Services to you in the manner prescribed above in the event that you fail to
        meet these eligibility requirements at any time, and you shall have no right of recourse or appeal against such
        decision.<br>
        <br>
        Privacy<br>
        <br>
        Please review our Privacy Policy , which also governs your visit to the Site. The personal information / data
        provided to us by you or your use of the Site will be treated as strictly confidential, in accordance with the
        Privacy Agreement and applicable laws and regulations. If you object to your information being transferred or
        used in the manner specified in the Privacy Agreement,you shall not be entitled to use the Site, or any of the
        services thereunder.
      </p>

      <p>
        Continued Availability of the Site<br>
        <br>
        We will do our utmost to ensure that access to the Site is consistently available and is uninterrupted and
        error-free. However, due to the nature of the Internet and the nature of the Site, this cannot be guaranteed.
        Additionally, your access to the Site may also be occasionally suspended or restricted to allow for repairs,
        maintenance, or the introduction of new facilities or services at any time without prior notice. We will attempt
        to limit the frequency and duration of any such suspension or restriction. <br>
        <br>
        License to Access the Site<br>
        <br>
        We grant you a non-transferable, revocable and non-exclusive license to use the Site, in accordance with the
        Terms and Conditions described herein. No person shall register as a member of the Site more than once. Any
        breach of these Terms and Conditions shall result in the immediate revocation of the license granted in this
        paragraph without notice to you.
      </p>

      <p>Content provided on this Site is solely for informational purposes. Submissions or opinions expressed on this
        Site are those of the individual(s) posting such content and do not reflect our opinions in any way whatsoever.
      </p>

      <p>We grant you a limited license to access and make personal use of this Site, but not to download (excluding
        page caches) or modify the Site or any portion of it in any manner. This license does not include any resale or
        commercial use of this Site or its contents; any collection and; any derivative use of this Site or its
        contents; any downloading or copying of Account information for the benefit of another party; or any use of data
        mining, robots, or similar data gathering and extraction tools.</p>

      <p>This Site or any portion of it (including but not limited to any copyrighted material, trademarks, or other
        proprietary information) shall not be reproduced, duplicated, copied, sold, resold, visited, distributed or
        otherwise exploited for any commercial purpose without express written consent by us as shall be applicable.</p>

      <p>You shall not frame or use framing techniques to enclose any trademark, logo, or other proprietary information
        (including images, text, page layout, or form) without our express written consent. You shall not use any meta
        tags or any other text utilizing our name or trademark without our express written consent, as applicable. Any
        unauthorized use terminates the permission or license granted by us to you for access to the Site with no prior
        notice. You shall not use our logo or other proprietary graphic or trademark as part of an external link for
        commercial or other purposes without our express written consent, as shall be applicable.</p>

      <p>You agree and undertake not to perform restricted activities listed within this section; undertaking these
        activities will result in an immediate cancellation of your Account, services, reviews, orders or any existing
        incomplete transaction with us and in severe cases may also result in legal action.</p>

      <p>
        Refusal to comply with the Terms and Conditions described herein or any other guidelines and policies related to
        the use of the Site as available on the Site at all times.<br>
        Impersonate any person or entity or to falsely state or otherwise misrepresent your affiliation with any person
        or entity.<br>
        Use the Site for illegal purposes, on any purposes other than what is explicitly permitted under these Terms and
        Conditions.<br>
        Attempt to gain unauthorized access to or otherwise interfere or disrupt other computer systems or networks
        connected to the Platform or Services.<br>
        Interfere with another&rsquo;s utilization and enjoyment of the Site.<br>
        Post, promote or transmit through the Site any prohibited materials as deemed illegal by the laws of Sri
        Lanka.<br>
        Post, promote or transmit through the Site any content or materials that promote hate speech, bigotry,
        discrimination, violence, pornography, or any other legally restricted/regulated matters.<br>
        Use or upload, in any way, any software or material that contains, or which you have reason to suspect that
        contains, viruses, damaging components, malicious code or harmful components which may impair or corrupt the
        Site&rsquo;s data or damage or interfere with the operation of another Customer&rsquo;s computer or mobile
        device or the Site and use the Site other than in conformance with the acceptable use policies of any connected
        computer networks, any applicable Internet standards and any other applicable laws. <br>
        <br>
        Your Conduct <br>
        <br>
        You shall not use the Site in any way that causes, or is likely to cause, the Site or access to it to be
        interrupted, damaged or impaired in any way. You must not engage in activities that could harm or potentially
        harm the Site, its employees, officers, representatives, stakeholders or any other party directly or indirectly
        associated with the Site or access to it to be interrupted, damaged or impaired in any way. You understand that
        you, and not us, are responsible for all electronic communications and content sent from your computer to us and
        you must use the Site for lawful purposes only. You are strictly prohibited from using the Site for;<br>
        <br>
        Fraudulent purposes, or in connection with a criminal offense or other unlawful activity to send, use or reuse
        any material that does not belong to you; or is illegal, offensive (including but not limited to material that
        is sexually explicit content or which promotes racism, bigotry, hatred or physical harm), deceptive, misleading,
        abusive, indecent, harassing, blasphemous, defamatory, libellous, obscene, pornographic, paedophilic or
        menacing; ethnically objectionable, disparaging or in breach of copyright, trademark, confidentiality, privacy
        or any other proprietary information or right; or is otherwise injurious to third parties; or in a manner that
        contravenes any anti-money laundering, know-your-customer and/or antiterrorism laws (&ldquo;AML Laws&rdquo;) or
        gambling; or is harmful to minors in any way; or impersonates another person; or threatens the unity, integrity,
        security or sovereignty of Sri Lanka or friendly relations with foreign States; or objectionable or otherwise
        unlawful in any manner whatsoever; or which consists of or contains software viruses, political campaigning,
        commercial solicitation, chain letters, mass mailings or any &quot;spam&rdquo; Use the Site for illegal
        purposes.<br>
        To cause annoyance, inconvenience or needless anxiety.<br>
        To purchase Products for third parties for the purposes of receiving further or additional payments from such
        third parties;<br>
        For any other purpose not intended by us.<br>
        <br>
        Your Submission<br>
        <br>
        Anything that you submit to the Site and/or provide to us, including but not limited to, questions, reviews,
        comments, and suggestions (collectively, &quot;Submissions&quot;) will become our sole and exclusive property
        and shall not be returned to you. In addition to the rights applicable to any Submission, when you post comments
        or reviews to the Site, you also grant us the right to use the name that you submit, in connection with such
        review, comment, or other content. You shall not use a false e-mail address, pretend to be someone other than
        yourself or otherwise mislead us or third parties as to the origin of any Submissions. We may, but shall not be
        obligated to, remove or edit any Submissions without any notice or legal course applicable to us in this regard.
      </p>

      <p>Claims Against Objectionable Content<br>
        <br>
        If you believe that any content on the Site is illegal, offensive (including but not limited to material that is
        sexually explicit content or which promotes racism, bigotry, hatred or physical harm), deceptive, misleading,
        abusive, indecent, harassing, blasphemous, defamatory, libellous, obscene, pornographic, paedophilic or
        menacing; ethnically objectionable, disparaging; or is otherwise injurious to third parties; or relates to or
        promotes money laundering or gambling; or is harmful to minors in any way; or impersonates another person; or
        threatens the unity, integrity, security or sovereignty of Sri Lanka or friendly relations with foreign States;
        or objectionable or otherwise unlawful in any manner whatsoever; or which consists of or contains software
        viruses, (&quot; objectionable content &quot;), please notify us immediately by following by writing to us at
        legal@paykoko.com. We will make all practical endeavours to investigate and remove valid objectionable content
        complained about within a reasonable amount of time.
      </p>

      <p>Please ensure to provide your name, address, contact information and as many relevant details of the claim
        including name of objectionable content party, instances of objection, proof of objection amongst others. Please
        note that providing incomplete details will render your claim invalid and unusable for legal purposes.<br>
        <br>
        Claims Against Infringing Content<br>
        <br>
        We respect the intellectual property of others. If you believe that your intellectual property rights have been
        used in a way that gives rise to concerns of infringement, please write to us at legal@paykoko.com and we will
        make all reasonable efforts to address your concern within a reasonable amount of time. Please ensure to provide
        your name, address, contact information and as many relevant details of the claim including name of infringing
        party, instances of infringement, proof of infringement amongst others. Please note that providing incomplete
        details will render your claim invalid and unusable for legal purposes. In addition, providing false or
        misleading information shall be considered a legal offense and may be followed by legal proceedings, at our
        whole and sole discretion.
      </p>

      <p>
        Trademarks and Copyrights<br>
        <br>
        KOKO, KOKO Logo and other marks indicated on our Site are trademarks or registered trademarks in the relevant
        jurisdiction(s). Our graphics, logos, page headers, button icons, scripts and service names are the trademarks
        or trade dress and shall not be used in connection with any product or service that does not belong to us or in
        any manner that is likely to cause confusion among customers, or in any manner that disparages or discredits us.
        All other trademarks that appear on this Site are the property of their respective owners, who may or may not be
        affiliated with, connected to, or sponsored by us.
      </p>

      <p>All intellectual property rights, whether registered or unregistered, in the Site, information content on the
        Site and all the website design, including, but not limited to text, graphics, software, photos, video, music,
        sound, and their selection and arrangement, and all software compilations, underlying source code and software
        shall remain our property. The entire contents of the Site also are protected by copyright, trade mark, service
        mark, patent or other proprietary rights and laws as under applicable laws and international conventions. All
        rights are reserved. <br>
        <br>
        Disclaimer<br>
        <br>
        We expressly disclaim any warranties or representations (express or implied) in respect of quality, suitability,
        accuracy, reliability, completeness, timeliness, performance, safety, merchantability, fitness for a particular
        purpose, or legality of the products listed or displayed or transacted or the content (including product or
        pricing information and/or specifications) on the Site. While we have taken precautions to avoid inaccuracies in
        content, this Site, all content, information, software, products, services and related graphics are provided as
        is, without warranty of any kind. We do not implicitly or explicitly support or endorse the sale or purchase of
        any products by the Participating Merchants. At no time shall any right, title or interest in the products sold
        by Participating Merchants vest with us nor shall we have any obligations or liabilities in respect of any of
        such transactions.<br>
        <br>
        We provide content or material on the Site that is provided by Participating Merchants, third-parties and other
        internet-based resources. We use best endeavours to ensure that content or material is correct, accurate,
        reputable, of high-quality and up-to-date and we do not make any warranties or guarantees in relation to that
        content or the providers of that content. Where any inaccuracy has been brought to our attention, we will
        attempt to correct any inaccuracies within a reasonable time and where practicable to do so.<br>
        <br>
        You acknowledge that you have not relied on any representation and/or warranty made by us which has not been
        expressly stated or referred to in this User Agreement.
      </p>

      <p>
        Limitation of Liability</p>

      <p>To the extent permitted by applicable law, Dinnovation (including its related bodies corporate, directors,
        employees, officers, agents and representatives) and any third parties providing services for or on behalf of
        Dinnovation shall not be liable for any direct, indirect, special, consequential, incidental or punitive damages
        (including without limitation loss of profits, loss of revenue and loss of data) arising out of or in connection
        with these Terms and Conditions and the Site. Dinnovation&rsquo;s liability to you for any non-excludable
        damages shall not exceed the value of any orders that are to the subject matter of such claim, including any
        Fees or Charges defined under clause 3,1 below that have been applied by Dinnovation against you.</p>

      <p>Indemnity</p>

      <p>You shall indemnify and hold harmless Dinnovation, its subsidiaries, affiliates and their respective officers,
        directors, shareholders, agents and employees, from any claim or demand, or actions including reasonable
        attorney's fees, made by any third party or penalty imposed due to or arising out of;</p>

      <p>Breach of these Terms and Conditions, the User Agreement, or any document incorporated by reference, or your
        violation of any law, rules, regulations or the rights of a third party, <br>
        Your negligence or willful misconduct;<br>
        Inability to repay debts on orders made using your Account, whether such orders were created directly by you or
        as a result of your negligence or inability to keep your Account secure; or<br>
        Inability to repay debts on orders made using your Account due to a change in your financial circumstances
        subsequent to the making of such order,<br>
        Actions/inactions of the Participating Merchants or other service providers and specifically waiver any claims
        or demands that you may have in this behalf under any statute, contract or otherwise<br>
        Save to the extent that such claim and/or subsequent damages or where it could be reasonably expected to do so,
        failed to reasonable steps to mitigate the claim and/or subsequent damages arises as a result of willful default
        or gross negligence on the part of Dinnovation, its directors, employees, officers, agents and representatives
        and those of any member of the Dinnovation group.</p>

      <p>Third Party Businesses<br>
        <br>
        We may provide links to the websites of affiliated companies, certain other businesses and Participating
        Merchants. We are not responsible for examining or evaluating, and we do not warrant or endorse the offerings of
        any of these businesses or individuals, or the content of their websites. We do not assume any responsibility or
        liability for the actions, products, and content of any of these and any other third-parties. You should
        carefully review their privacy statements and related terms and conditions.<br>
        <br>
        Communicating with us
      </p>

      <p>When you visit the Site, or send emails to us, you are communicating with us electronically. You will be
        required to provide a valid phone number while placing an order with us. We may communicate with you by email,
        SMS, phone call or by posting notices on the Site to the registered address or shipping or billing address (as
        the case may be) associated with your Account or by any other mode of communication we choose to employ. For
        contractual purposes, you consent to receive communications (including transactional, promotional and/or
        commercial messages), from us with respect to your use of the Site (and/or placement of your order) and agree to
        treat all modes of communication with the same importance.<br>
        <br>
        All notices or other communications between the parties shall be given in writing and in the English
        language.<br>
        <br>
        Losses<br>
        <br>
        We will not be responsible for any business or personal losses (including but not limited to loss of profits,
        revenue, contracts, anticipated savings, data, goodwill, or wasted expenditure) or any other indirect or
        consequential loss that is not reasonably foreseeable to both you and us when you commenced using the Site.<br>
        <br>
        Amendments to Conditions or Alterations of Service and Related Promise<br>
        <br>
        We reserve the right to make changes to the Site, its policies, these terms and conditions and any other
        publicly displayed condition or service promise at any time. You will be subject to the policies and terms and
        conditions in force at the time you used the Site unless any change to those policies or these conditions is
        required to be made by law or government authority (in which case it will apply to orders previously placed by
        you). If any of these conditions is deemed invalid, void, or for any reason unenforceable, that condition will
        be deemed severable and will not affect the validity and enforceability of any remaining condition.<br>
        <br>
        Events Beyond Our Control<br>
        <br>
        We will not be held responsible for any delay or failure to comply with our obligations under these conditions
        if the delay or failure arises from any cause which is beyond our reasonable control. This condition does not
        affect your statutory rights.<br>
        <br>
        Waiver<br>
        <br>
        You acknowledge and recognize that we are a private commercial enterprise and reserve the right to conduct
        business to achieve our objectives in a manner we deem fit. You also acknowledge that if you breach the
        conditions stated on our Site and we take no action, we are still entitled to use our rights and remedies in any
        other situation where you breach these conditions.<br>
        <br>
        Termination<br>
        <br>
        In addition to any other legal or equitable remedies, we shall reserve the right to, without prior notice to
        you, immediately terminate the Terms and Conditions or revoke any or all of your rights granted under the Terms
        and Conditions. Upon any termination of this Agreement, you shall immediately cease all access to and use of the
        Site and we shall, in addition to any other legal or equitable remedies, immediately revoke all password(s) and
        Account identification issued to you and deny your access to and use of this Site in whole or in part. Any
        termination of this User Agreement shall not affect the respective rights and obligations (including without
        limitation, payment obligations) of the parties arising before the date of termination. You furthermore agree
        that the Site shall not be liable to you or to any other person as a result of any such suspension or
        termination. If you are dissatisfied with the Site or with any terms, conditions, rules, policies, guidelines,
        or practices in operating the Site, your sole and exclusive remedy is to discontinue using the Site.<br>
        <br>
        Our Software<br>
        <br>
        Our software includes any software (including any updates or upgrades to the software and any related
        documentation) that we make available to you from time to time for your use in connection with the Site (the
        &quot;Software&quot;).
      </p>

      <p>You shall use the software solely for purposes of enabling you to use and enjoy our services as permitted by
        the Terms and Conditions and any related applicable terms as available on the Site. You shall not incorporate
        any portion of the Software into your own programs or compile any portion of it in combination with your own
        programs, transfer it for use with another service, or sell, rent, lease, lend, loan, distribute or sub-license
        the Software or otherwise assign any rights to the Software in whole or in part. You shall not use the Software
        for any illegal purpose. We reserve the right to cease providing you service and terminate your right to use the
        Software at any time. Your rights to use the Software will automatically terminate without notice from us if you
        fail to comply with any of the Terms and Conditions listed here or across the Site. Additional third-party terms
        contained within the Site or distributed as such that are specifically identified in related documentation shall
        apply and shall govern the use of such software in the event of a conflict with these Terms and Conditions. All
        software used in any of our services is our property and/or our affiliates or its software suppliers and
        protected by the laws of Sri Lanka including but not limited to any other applicable copyright laws.</p>

      <p>When you use the Site, you may also be using the services of one or more third parties, such as a wireless
        carrier or a mobile platform provider. Your use of these third party services shall be subject to separate
        policies, terms of use, and fees of these third parties.</p>

      <p>All Intellectual Property Rights in and related to the Site, its composite engineering, know-how and processes
        shall be and shall remain the exclusive property of Dinnovation.<br>
        <br>
        You shall not, and you will not encourage, assist or authorize any other person to copy, modify, reverse
        engineer, decompile or disassemble, or otherwise tamper with our software whether in whole or in part, or create
        any derivative works from or of the Software.
      </p>

      <p>In order to keep the Software up-to-date, we may offer automatic or manual updates at any time and without
        notice to you.<br>
        <br>
        Governing Law and Jurisdiction<br>
        <br>
        These terms and conditions are governed by and construed in accordance with the laws of The Democratic Socialist
        Republic of Sri Lanka. You agree, as we do, to submit to the exclusive jurisdiction of the courts of Sri Lanka
        having jurisdiction over the place on which our Registered Office is situated at the time of institution of
        legal proceedings.<br>
        <br>
        CONDITIONS RELATED TO SERVICES<br>
        <br>
        This section deals with conditions relating to the services on the Site.<br>
        <br>
        Payment, fees and charges
      </p>

      <p>All fees and charges (&ldquo;Fees&rdquo; and Charges&rdquo;) associated with an order are maintained in the
        Schedule of these Terms and Conditions and we reserve the right to alter those Fees and Charges at our sole
        discretion, and will in such case amend these Terms and Conditions and publish the amended Terms and Conditions
        on the Site.</p>

      <p>Any late payment charges incurred are calculated based on the value of the order created in the Site as a
        result of a successful transaction between you and a Participating Merchant using the Site to effect payment and
        are tabled in the Schedule to these Terms and Conditions as well as available on the Site.</p>

      <p>In the case of refunds and reversals, the late payment charges will be adjusted in the following manner:<br>
        In the case of a partial Refund, any late payment charges shall be calculated based on the revised Order Value
        Post-Refund;<br>
        In the case of a full Refund or a Reversal, we will remove any late payment charges applied against outstanding
        instalments for such Refunded or Reversed Order.</p>

      <p>We reserve the right to remove, reverse, waive or void generally any late payment charge at its sole
        discretion.</p>

      <p>Payment of outstanding debts owed by you to us may be:</p>

      <p>Made automatically: we reserve the right to obtain monies from the payment method nominated by you (Nominated
        Payment Method), automatically to pay an instalment on the scheduled due date, and such monies will first be
        applied against that instalment and any surplus monies (if any) obtained by us will be applied against any other
        outstanding debts on your Account; or</p>

      <p>Made manually: you shall make manual payments in respect of outstanding debts owed by you to us and which are
        not subject to automatic deduction from your Nominated Payment Method, and such manual payments will be applied
        in the following order of priority until the monies have all been used:</p>

      <p>First, to any outstanding instalments;<br>
        Second, to any outstanding fees that shall be imposed by Dinnovation on you as a result of activities performed
        in association with your Account as requested by you.<br>
        Third, to any outstanding charges (excluding any Late Payment fees) that shall be imposed by Dinnovation on you
        as a result of your failure to comply with your obligations, including late payment charges., and<br>
        Last, to any outstanding late payment charges;</p>

      <p>You may also make manual payments for future instalments which are yet to fall due, provided that you have no
        outstanding debts owed to us at that point in time, and such manual payments shall be applied against future
        instalments in the order that they would have become due. Any surplus monies will be refunded to your Nominated
        Payment Method.</p>

      <p>Where there are any surplus monies which exist as credits in your Account and you have no outstanding debts,
        you may request for a refund and we will endeavor to refund such monies to you as soon as practicable.</p>

      <p>We reserve the right to:</p>

      <p>Limit the number of credit cards or debit cards used to pay your instalments within a period of time as may be
        determined by us in its sole discretion;<br>
        Limit the amount of manual payments that you shall make in respect of your Account and your orders;<br>
        Only accept any repayment on any order made after 21 days from the date of the creation of the relevant order
        and to reject all attempted repayments before such time;<br>
        Place any additional limitations on you, Participating Merchants, credit cards or debit cards, devices and
        Accounts as we may deem fit and reasonable to protect its financial exposure.</p>

      <p> Disputes, reversal and refunds</p>

      <p>In the event of any dispute between the you and a Participating Merchant:</p>

      <p>You shall contact the Participating Merchant directly to file your dispute with them;<br>
        You should notify us of such ongoing disputes so that we are aware of the dispute and can take appropriate
        action.<br>
        If you are unable to resolve the dispute with the Participating Merchant, you shall raise the matter with us and
        we will use reasonable endeavours in good faith to (but shall not be obliged to) mediate and resolve such
        dispute, and in such case you acknowledge that we are not obliged to intervene and that the Participating
        Merchant is not obliged to follow our directions regarding such dispute; and<br>
        You acknowledge that notwithstanding an ongoing dispute, you remain liable to us for any outstanding debts
        related to the order in dispute.</p>

      <p>In the event of a Refund:</p>

      <p>It is your duty to notify the Participating Merchant of any refund request and to comply with the Participating
        Merchant&rsquo;s refund process and any other statutory requirements in relation to such refund process, and you
        and the Participating Merchant shall reach an agreement regarding the refund amount without our involvement and
        prior to the Participating Merchant lodging a refund request with us;<br>
        The Participating Merchant shall lodge such refund request with us within fourteen days (14) calendar days of
        the creation of the order and any refund request beyond this time must be expressly agreed between you and the
        Participating Merchant, and the Participating Merchant shall notify us within 24 hours of such agreement to
        refund;<br>
        Where a full refund is agreed as between you and the Participating Merchant, you shall return the disputed
        Product(s) (where applicable) to the Participating Merchant and the Participating Merchant shall acknowledge
        receipt of the disputed Product(s), upon which:<br>
        we will refund such amount that you have already paid in relation to the disputed order; and<br>
        Your Account will be updated to reflect the full refund.</p>

      <p>Where a partial refund is agreed as between you and the Participating Merchant, you shall return the disputed
        Product(s) (where applicable) to the Participating Merchant and the Participating Merchant shall acknowledge
        receipt of the disputed Product(s), upon which:<br>
        We will prorate the instalments according to the revised order value taking into account the partial refund;<br>
        In respect of each instalment repayment already made, we will credit your Account with an amount equivalent to
        the difference between the original and pro-rated instalment;<br>
        Such credits may be used to pay the prorated instalments that become due and payable; and<br>
        Where such credits are insufficient, you will top up the outstanding balance; and<br>
        Where such credits exceed the outstanding debt such that additional credits remain after all pro-rated
        instalments have been repaid, we will refund the value of such additional credits to you; and<br>
        Your Account will be updated to reflect the partial refund.</p>

      <p>For the avoidance of doubt, we are not obliged to contact or to seek a refund or reversal on your behalf or on
        the behalf of the Participating Merchant and we are not obliged to do anything until the Participating Merchant
        lodges a refund request.</p>

      <p>Upon receipt of a reversal or refund request, we shall, within a reasonable time, process such request and pay
        such refund amount to our payment processor to be processed in line with the payment processor&rsquo;s
        practices. In this regard, you acknowledge and agree that any refund amount due to be repaid to your nominated
        payment method is subject to handling methods outside our control and you shall not hold us responsible for any
        delays caused directly or indirectly by any financial institution or its agents associated with your nominated
        payment method.</p>

      <p>Terms and Conditions – Adding a bank account on Koko through JustPay</p>

      <p>
        All payments, fees and charges associated with your order placed through Koko shall be deducted from your bank
        account through the payment service "JustPay". Your use of "JustPay" is conditioned on your acceptance of and
        compliance with the Koko Standard User Terms and Conditions. By accessing or using this payment service you
        agree to accept and be bound by these Standard User Terms and Conditions.
      </p>

      <p>Tax</p>

      <p>You shall be solely responsible for any matters relating to tax or additional fees arising from your use of the
        Site as per law, including but not limited to: tax determination; payment of any taxes or fees required by any
        governmental or regulatory authority; and payment of any fees or commission incurred in connection with any
        exchange of monies associated with any order;<br>
        <br>
        Representations and warranties<br>
        <br>
        We do not make any representation or warranty as to specifics (such as quality, value, saleability, etc) of the
        Products sold by Participating Merchants. We do not implicitly or explicitly support or endorse the sale or
        purchase of any Products from the Participating Merchants. We accept no liability for any errors or omissions,
        whether on behalf of itself or third parties.
      </p>

      <p>We are not responsible for any non-performance or breach of any contract entered into between you and the
        Participating Merchants. We cannot and do not guarantee your actions or those of the Participating Merchants. We
        are not required to mediate or resolve any dispute or disagreement arising from transactions between you and any
        Participating Merchant.</p>

      <p>We do not have any obligations or liabilities in respect of any transaction between you and the Participating
        Merchants. <br>
        <br>
        Consumer Status Tier<br>
        <br>
        We may assign you, and/or other consumers with a Consumer Status Tier that a consumer is classified into as part
        of a tiered system within the Site, (&ldquo;Consumer Status Tier&rdquo;), which is determined in real-time based
        on various factors as we may determine from time to time in our sole discretion, and such Consumer Status Tier
        may influence which may influence, among other things, your Purchase Limit and any other entitled benefits
        relating to your use of the Services. Purchase Limit means the maximum amount of financial exposure or the
        number of concurrent Orders that you are allowed to accumulate for orders made using the Site. Such Purchase
        Limit may factor into account the Consumer Status Tier of the Consumer.
      </p>

      <p>Validations, Checks and Risk Assessments</p>

      <p>In respect of any order, we shall reserve the right to conduct the following checks and assessments:</p>

      <p>Real-time checks and validations on the Participating Merchant&rsquo;s eligibility, exposure limit, product
        risk and other matters relating to Participating Merchants and the transaction; real-time checks and validations
        on your eligibility;<br>
        Real-time checks and validations your credentials, devices, relationships with our other consumers and other
        historical data; <br>
        Purchase Limit assessments based on your Consumer Status Tier, the Order Value, the risks associated with the
        Products in the order and your potential capability to repay the overall debt;<br>
        And where we are satisfied with the eligibility of both you and the Participating Merchant at the time of making
        the Order, we will create an order associated with you in our Site for the order value provided to us by the
        Participating Merchant.</p>

      <p>Placement of Orders</p>

      <p>Each time you make an order, these Terms and Conditions as they stand on the date of placement of the order,
        shall be applicable to such order.<br>
        For every order you make, you give unconditional and irrevocable consent for us to pay the corresponding order
        value to the Participating Merchant on your behalf, and you agree to pay your Instalments according to the
        repayment schedule.</p>

      <p>Upon making of your order, we will advise you of the outcome of such order request:<br>
        Where the order request is unsuccessful, we will provide you with a reason for the failure and allow you to
        attempt the order again for a maximum number of tries within a period of time as we may determine in our sole
        discretion;<br>
        Where the order request is successful, we will provide you with your repayment schedule and an email receipt for
        your first Instalment paid (where applicable), and we will notify the Participating Merchant of the successful
        order to request that they fulfil your order.</p>

      <p>Rejection or Cancellation of Orders</p>

      <p>All Orders placed are subject to our assessment and discretion and we reserve the right to reject or cancel an
        order where:<br>
        We have a reason to suspect, or becomes aware, that you may have or have materially breached these Terms and
        Conditions;<br>
        You fail to satisfy any of our validations, checks and assessments;<br>
        Requested by the Participating Merchant associated with the order, and in such case we are not responsible for
        such rejection or cancellation and you should reach out to the Participating Merchant should you have any
        queries relating to it;<br>
        You have exceeded or will exceed your Purchase Limit;<br>
        The Participating Merchant associated with the order has exceeded or will exceed its exposure limits;<br>
        We suspect or becomes aware of suspicious activity from you within our Site which may contravene applicable laws
        and/or regulations including, but not limited to, AML Laws; or<br>
        We suspect or becomes aware generally that the Participating Merchant and/or their systems have been or may have
        been compromised,<br>
        Where the Product from the cancelled Order has not been delivered to you, we will, on a best endeavours basis,
        refund the monies paid by you and associated with the cancelled Order to the same nominated payment method.</p>

      <p>Instalment Repayments</p>

      <p>Your repayment to us of the order value will be split into such number of separate and equal instalments over a
        specified period of time as shall be determined by us at our sole discretion (&ldquo;Instalments&rdquo;).</p>

      <p>Where the order value cannot be evenly split into such a number of equal Instalments as shall be determined by
        us at our sole discretion, we may adjust the Instalments accordingly and will ensure that the total amount due
        to be paid by you remains unchanged.</p>

      <p>We will generate a repayment schedule at our discretion and based on your Consumer Status Tier, outstanding
        debts (if any), and track record of previous Orders and Instalment Repayments (&ldquo;Repayment
        schedule&rdquo;), and depending on the Repayment Schedule generated, your first Instalment shall be due:<br>
        At the time of making the order; or<br>
        At such a later time after the order is made as may be determined by us at our sole discretion.</p>

      <p>Where your first Instalment is due at the time of making the order and you are unable to pay the first
        Instalment (whether due to insufficient funds in your Nominated Payment Method, or the transaction is declined
        by the relevant financial institution, or a general failure of the online payment process), we may decline the
        order request.</p>

      <p>We will remind you in advance of each Instalment and their respective scheduled due dates via email. You
        undertake to ensure that your Nominated Payment Method has sufficient funds to pay the Instalments on their
        respective scheduled due dates.</p>

      <p>In the event that any Instalment Repayment is unsuccessful due to a failure to obtain funds from your Nominated
        Payment Method, we will advise you accordingly and grant you an immediate grace period to pay such Instalment
        through alternative payment methods nominated by you.</p>

      <p>If you are unable to pay your Instalments, you shall contact us via email at accounts@paykoko.com to discuss
        and put in place a suitable Repayment Plan.</p>

      <p>If you fail to pay an Instalment on the scheduled due date and within any accompanying grace period (where
        applicable), and you have not contacted us with respect to a suitable repayment plan, we may impose a late
        payment charge in accordance with the Schedule.</p>

      <p>Upon successful payment of all Instalments relating to an order, we will advise you accordingly and notify you
        of any outstanding debts which you shall owe to us (as a result of late payment charges or otherwise).</p>

      <p>Complaints</p>

      <p>If you have any complaints regarding your Account, Instalment repayment calculations, outstanding debts, any of
        our staff or any other matter relating to us, please contact us at the details below to raise a formal
        complaint:</p>

      <p>Email: accounts@paykoko.com<br>
        Post: Dinnovation (Private) Limited, , 14 Sir Baron Jayatilaka Mawatha, Colombo 00100.</p>

      <p>We aim to respond to you within 72 hours of receiving such complaint and to resolve the matter within fourteen
        (14) working days of receiving such complaint, failing which we will notify you of the reason(s) for such delay
        and if any further information or action is required from you, and you agree to provide us with all reasonable
        assistance, including providing any additional information requested of you, to resolve the matter.</p>

      <p>For the avoidance of doubt, we will not accept any complaints arising out of your incapacity to pay your
        Instalments.</p>

      <p>Additional acknowledgements</p>

      <p>You acknowledge that:<br>
        You are aware that you can access KOKO&rsquo;s other policies online on the Site, and you have read, understood
        and agreed to these policies as we may publish from time to time;<br>
        We doe not keep version-controlled copies of these Terms and Conditions and other policies in a publicly
        accessible archive and you are expected to keep a copy of these documents should you wish to keep track of
        them;<br>
        We do not have any control over the Products offered by Participating Merchants and is not responsible or liable
        for the quality or delivery of these Products, and Participating Merchants remain responsible for fulfilling
        orders made by you in a timely manner and/or accepting any Refunds;<br>
        You are aware of your consumer rights under Sri Lanka law and that these rights extend to your purchase of
        Products from Participating Merchants, and nothing in these Terms and Conditions is intended to modify, exclude,
        restrict or deny any of your rights under Sri Lanka law;<br>
        We are not required to guarantee the identity of any Participating Merchant and/or their staff.</p>

      <p>Transfer and assignment</p>

      <p>You shall not transfer or assign any of its rights and obligations under these Terms and Conditions without our
        prior written consent.</p>

      <p>Dinnovation may transfer, assign or novate these Terms and Conditions and any rights and obligations under
        these Terms and Conditions to a third party without your consent and/or notice.</p>

      <p>You acknowledge and agree that we reserve the right to, without your notice or consent, appoint and engage
        third party debt collection agencies to carry out and enforce any actions in relation to any outstanding debt
        owed by you to us.<br>
        Schedule</p>

      <p>Order Creation Charges<br>
        Consumers shall bear the following costs associated with each Order made:<br>
        Fees: NIL<br>
        Charges: NIL</p>

      <p>Rescheduling Charges<br>
        The following rescheduling charges will be applicable if you would like to change the due date of your payment
        schedule prior to the due date. <br>
        Charges: LKR 500</p>

      <p>Late Payment Charges<br>
        The following Late Payment Charges of LKR 1,500 will be applicable if you fail to pay any Instalment(s) by their
        Scheduled Due Date and any accompanying grace period (where applicable).<br>
        Charges: LKR 1,500 <br>
      </p>

    </div>
  </div>

  <FooterWeb />

</template>

<script>
import NavBarWeb from "@/components/NavBarWeb";
import FooterWeb from "@/components/FooterWeb";
export default {
  name: "Terms",
  components: { FooterWeb, NavBarWeb },

  methods: {
    test() {
      console.log("gdiabwdouba");
      window.webkit.messageHandlers.testHandler.postMessage("hello");
    },
  },
}

</script>

<style scoped>
.sectionKoko {
  padding-top: 60px;
  padding-bottom: 60px;
}

.sectionHead {
  font-family: Raleway;
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  /* line-height: 42px; */

  color: #393939;

}

.sectionBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  padding-top: 10px;
  padding-bottom: 10px;
  color: #393939;

  opacity: 0.8;

}
</style>